<template>
<modal name="payment-options" height="auto" :width="600" :pivotX="0" :pivotY=".15" @before-open="assignParams">

  <aside class="window payment-options">
    <header class="window__header">
      <h1 class="window__title">Payment options</h1>
      <p class="window__description window__description--active">
        <span style="color: green;" v-if="coupon && !coupon.used && !isCouponExpired">Active Coupon</span>
        <span v-if="coupon && coupon.used && !isCouponExpired">Coupon has been used already <br> You can still sign up at regular price below</span>
        <span v-if="coupon && !coupon.used && isCouponExpired">Coupon Expired</span>
      </p>
      <p class="window__description">
        {{plan.name}} Plan <br> <span :class="{'window__description--strikethrough': coupon && !coupon.used && !isCouponExpired}">(${{plan.price / 100}} billed {{plan.term}}ly)</span> <br> <span v-if="coupon && !coupon.used && !isCouponExpired">(${{(plan.price / 100) - coupon.amount_discounted}} billed {{plan.term}}ly)</span>
      </p>
    </header>

    <section class="window__content">
      <section class="card-select">
        <section class="card-select__panels">
          <credit-card-form :bus="bus" style="margin: 1em;" v-if="needsCard()"></credit-card-form>
          <a href="#" v-on:click="cancelUpdateCard" v-if="billing.newCard && billing.last4" class="button button--secondary add-card-btn">Cancel</a>
          <div v-if="billing.id && !billing.newCard && billing.cardType" style="min-width: 450px;text-align:right;">
            <span style="margin-right:1em;display:inline-block;">{{billing.cardType}} ending in {{billing.last4}} and expiring on {{billing.exp}}</span>
            <a style="display:inline-block" href="#" v-on:click.prevent="updateCard" class="button button--secondary">Update</a>
          </div>
        </section>
      </section>
    </section>

    <footer class="window__footer">
      <a href="#" v-on:click.prevent="save" class="window__button button button--primary button--large">{{ needsCard() ? "Add Card" : "Confirm" }}</a>
      <small @click="removeCoupon" class="form__item__description clickable">Don't show again</small>
      <figure class="secure">
        <figcaption class="secure__label">Connection is private</figcaption>
      </figure>
    </footer>
  </aside>

</modal>
</template>

<script>
import store from '../../store'
import CreditCardForm from '../common/CreditCardForm.vue'
import Vue from 'vue'
import { getPlans } from '../../lib/api/calls'

export default {
  name: 'PaymentOptions',
  components: {
    CreditCardForm
  },
  mounted(){
    this.bus.$on('creditCardEntered', ()=>{
      this.billing.dirty = true;
    });

    store.subscribe(function(mutation, state){
      if(state.me.name) this.name = state.me.name;
      if(state.account.id){
        if (this.coupon) {
          this.billing = _.extend(this.billing, {
            id: state.account.id,
            last4: state.account.card_last_4,
            cardType: state.account.card_type,
            exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
          })
        } else {
          this.billing = _.extend(this.billing, {
            id: state.account.id,
            plan: state.account.plan,
            plan_id: state.account.plan_id,
            last4: state.account.card_last_4,
            cardType: state.account.card_type,
            exp: [state.account.card_exp_month, state.account.card_exp_year].join('/')
          })
        }
      }
    }.bind(this));

    this.bus.$on('cardValidated', (token) => {
      this.billing.token = token;
      this.executeUpdatingAccount();
    })
  },
  data(){
    return {
      bus: new Vue(),
      plan: {},
      billing: {
        plan: {},
        plan_id: null,
        token: null,
        dirty: false,
        last4: null,
        cardType: null,
        newCard: false,
        coupon: null,
        coupon_id: null
      },
      coupon: null
    }
  },
  methods: {
    executeUpdatingAccount () {
      if (this.coupon && !this.coupon.used && !this.isCouponExpired) {
        this.billing.coupon_id = this.coupon.id
        this.billing.coupon = this.coupon
      }

      store.dispatch('accounts/update', this.billing).then(() => {
        this.$router.push(this.$route.path)
        if (this.coupon) {
          delete localStorage.coupon_token
        }
        FS.event('Signed Up', {
          plan_name_str: this.billing.plan.name,
          plan_id: this.billing.plan_id,
          coupon_code_str: this.coupon.token,
          amount_discounted: this.coupon.amount_discounted
        });

        if (this.isProduction()) {
          var image = document.createElement('img');
          var script = document.createElement('script');
          script.src = 'https://www.dwin1.com/19038.js';
          script.defer = 'defer';
          script.type = 'text/javascript';
          image.src = `https://www.shareasale.com/sale.cfm?tracking=${this.billing.id}p${this.billing.plan_id}c${this.billing.coupon_id}&amount=${((this.billing.plan.price / 100) - this.coupon.amount_discounted).toFixed(2)}&merchantID=97774&transtype=sale`;
          image.width = '1';
          image.height = '1';

          document.body.appendChild(image);
          document.body.appendChild(script);
        }
      })
      this.hide();

      setTimeout(()=>{
        store.dispatch('accounts/loadOwned');
        if(window.afterCompleteBillingModal) window.afterCompleteBillingModal();
      }, 100);
    },
    removeCoupon () {
      localStorage.removeItem('coupon_token')
      this.$modal.hide('payment-options')
    },
    assignParams (event) {
      if (!event.params.id) {
        if (event.params.coupon) {
          getPlans().then(plans => {
            this.plan = plans.find(plan => plan.id == event.params.coupon.plan_id)
            this.billing.plan = this.plan
            this.billing.plan_id = this.plan.id
          });

          this.coupon = event.params.coupon
        } else {
          getPlans().then(plans => {
            setTimeout(() => {
              this.plan = plans.find(plan => plan.short_name == event.params)
              this.billing.plan = this.plan;
              this.billing.plan_id = this.plan.id
            }, 1000)
          })
        }
      } else {
        this.plan = event.params
        this.billing.plan = this.plan
        this.billing.plan_id = this.plan.id
      }
    },
    hide () {
      this.$modal.hide('payment-options')
    },
    save(){
      if (this.needsCard()) {
        this.bus.$emit('billingFormSaved');
      } else {
        this.executeUpdatingAccount();
      }
    },
    updateCard(e){
      e.preventDefault();

      this.billing.newCard = true;
    },
    cancelUpdateCard(e){
      e.preventDefault();

      this.billing.newCard = false;
    },
    needsCard () {
      return !this.billing.id || this.billing.newCard || !this.billing.cardType
    }
  },
  computed: {
    isCouponExpired () {
      return (new Date(this.coupon.expiration_date).getTime() < new Date().getTime())
    }
  }
}
</script>

<style scoped>
  .button {
    margin: 10px;
  }

  .add-card-btn {
    margin: 10px auto;
    display: block;
    width: 50%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/PaymentOptions.vue